import styled from '@emotion/styled';
import React from 'react';
import { ThemeProps } from '@theme/base';
import { WarningBox } from '@styles/common';

/* ***************** *
 *       Types       *
 * ***************** */
export interface TileDiscountBoxProps {
  header?: string;
  children: JSX.Element | Array<JSX.Element>;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const DiscountBox = styled(WarningBox)(({ theme }: ThemeProps) => ({
  borderRadius: 10,
  boxShadow: 'rgb(191, 191, 191) 0px 1px 2px 0px',
  padding: theme.custom.spacing.large,
  whiteSpace: 'pre-line',
  ['p']: {
    marginBottom: 0
  }
}));

export const Header = styled.h5(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h5 as any),
  margin: `0 0 ${theme.custom.spacing.small}px 0`
}));

/* **************** *
 *    PromoBanner   *
 * **************** */

export const TileDiscountBox = ({ header, children }: TileDiscountBoxProps) => {
  return (
    <DiscountBox>
      {header && <Header>{header}</Header>}
      {children}
    </DiscountBox>
  );
};
